import React from "react";

type LayoutImportRunHeadingContextValue = {
  setImportRunPageHeading: (title: string | null) => void;
};

export const LayoutImportRunHeadingContext = React.createContext<LayoutImportRunHeadingContextValue>({
  setImportRunPageHeading: () => {}
});

export function useSetImportRunPageHeading(): (title: string | null) => void {
  return React.useContext(LayoutImportRunHeadingContext).setImportRunPageHeading;
}
